import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReduxBlockUi from 'react-block-ui/redux';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';
import {
	fetchWeeklyProgramItem, loadWeeklyProgram,
	WEEKLY_PROGRAM_ITEM_REQUEST, WEEKLY_PROGRAM_ITEM_SUCCESS, WEEKLY_PROGRAM_ITEM_FAILURE,
} from '../../dashboard/common/actions';
import { getChild } from '../../dashboard/reducer';
import analyticsTracker, { AnalyticsPlatforms } from '../../common/services/analyticsTracker';
import moment from 'moment';
import FontAwesome from 'react-fontawesome';
import {
	loadBookingOptions, selectPaymentType, selectChild, startEnrolment, selectJoinWaitingList,
	BOOKING_OPTIONS_FETCH_REQUEST, BOOKING_OPTIONS_FETCH_SUCCESS, BOOKING_OPTIONS_FETCH_FAILURE
} from '../../dashboard/booking/actions';
import ClassDetailsView from '../../dashboard/booking/listView/Details';
import BookingOptions from '../../dashboard/booking/listView/BookingOptions';
import {
	CHILDREN_GRADES_REQUEST, CHILDREN_GRADES_SUCCESS, CHILDREN_GRADES_FAILURE
} from '../../dashboard/actions';
import BackButton from '../../common/components/BackButton';
import queryString from 'query-string';
import { getActiveLanguage } from '../../languages/reducer';
import availabilityUtils from '../../dashboard/booking/availabilityUtils';
import utils from '../../common/services/utils';
import RecommendedNearbyCenters from '../../dashboard/booking/RecommendedNearbyCenters';

class ClassDetails extends Component {
	constructor(props) {
		super(props);

		this.handleStartDateSelect = this.handleStartDateSelect.bind(this);
		this.handlePaymentTypeSelect = this.handlePaymentTypeSelect.bind(this);
		this.handleBookingOptionsConfirm = this.handleBookingOptionsConfirm.bind(this);
		this.handleJoinWaitingList = this.handleJoinWaitingList.bind(this);
	}

	componentDidMount() {
		this.props.fetchWeeklyProgramItem(Number(this.props.centerId), Number(this.props.weeklyProgramItemId));

		// track view with item already loaded from the list
		if (this.props.weeklyProgramItem && this.props.weeklyProgramItem.grade.name && this.props.weeklyProgramItem.center.name && this.props.weeklyProgramItem.term.name) {
			this.trackView(this.props.weeklyProgramItem);
		}

		window.scrollTo(0, 0);
	}

	componentWillReceiveProps(nextProps) {
		// track view on refresh after all nested entities are loaded
		if ((!this.props.weeklyProgramItem || !this.props.weeklyProgramItem.grade.name || !this.props.weeklyProgramItem.center.name || !this.props.weeklyProgramItem.term.name) &&
			nextProps.weeklyProgramItem && nextProps.weeklyProgramItem.grade.name && nextProps.weeklyProgramItem.center.name && nextProps.weeklyProgramItem.term.name) {
			this.trackView(nextProps.weeklyProgramItem);

			// load weekly program to check availability in nearby centers if no availability in this class
			const availability = availabilityUtils.getWeeklyProgramItemAvailability(nextProps.weeklyProgramItem, nextProps.bookingOptions.lessonType, nextProps.paymentTypes);
			if (availability === 'No' && nextProps.franchisor.recommendNearbyCenters) {
				this.loadNearbyCentersProgram(nextProps);
			}
		}
	}

	trackView({ grade, center, term }) {
		analyticsTracker.trackEvent('view_item', {
			items: [
				{
					item_id: grade.id,
					item_name: grade.name,
					item_brand: center.name,
					item_category: `${term.name}, ${term.schoolYear}`
				}
			]

		}, AnalyticsPlatforms.GoogleAnalytics);
	}

	loadNearbyCentersProgram(props) {
		const { weeklyProgramItem, centers, loadWeeklyProgram, franchisor } = props;

		const closestCenters = utils.findClosestCenters(weeklyProgramItem.center, centers, franchisor.distanceToNearbyCenters);
		closestCenters.forEach(center => {
			loadWeeklyProgram(center.id, weeklyProgramItem.termId,
				null,			// load all grades
				[1, 2, 3, 4],	// load all lessons - normal, trial, makeup, single
				false);			// mark as not selected center
		});
	}

	handleStartDateSelect(startDate) {
		const { loadBookingOptions, centerId, weeklyProgramItemId, bookingOptions: { lessonType } } = this.props;

		loadBookingOptions({
			programId: weeklyProgramItemId,
			date: startDate,
			childId: 0,
			lessonType: lessonType,
			centerId: centerId
		});
	}

	handlePaymentTypeSelect({ paymentTypeId, isPrepaid, isBonusLesson, annualPaymentLength }) {
		this.props.selectPaymentType({ paymentTypeId, isPrepaid, isBonusLesson, annualPaymentLength });
	}

	handleBookingOptionsConfirm() {
		const { franchisor, centerId, weeklyProgramItem, bookingOptions } = this.props;
		const { selectedPaymentTypeId, selectedChildId, childrenPaymentTypes, date } = bookingOptions;
		const childPaymentOptions = childrenPaymentTypes.find(x => (!selectedChildId && !x.child) || x.child.id === selectedChildId);
		const paymentOptions = childPaymentOptions && childPaymentOptions.paymentTypes.find(x => x.id === selectedPaymentTypeId);

		this.props.startEnrolment({
			centerId,
			programId: weeklyProgramItem.id,
			startDate: date,
			paymentTypeId: selectedPaymentTypeId,
			currency: franchisor.currency,
			quantity: paymentOptions && paymentOptions.quantity,
			unitPrice: paymentOptions && paymentOptions.unitPriceAmount,
			total: paymentOptions && paymentOptions.totalAmount,
			lesson: weeklyProgramItem
		});
		this.props.history.push('/register', { from: '/booking/child' });
	}

	handleJoinWaitingList() {
		this.props.selectJoinWaitingList();
		this.props.history.push('/register', { from: '/booking/child' });
	}

	render() {
		const { weeklyProgramItem, centerId, userImpersonation, fromTimetable, bookingOptions: { lessonType, postTrial }, t, franchisor } = this.props;
		const center = weeklyProgramItem && weeklyProgramItem.center;

		const now = new Date();
		const allLessonDates = weeklyProgramItem ? weeklyProgramItem.lessons.map(x => x.start).sort((a, b) => a - b) : [];
		const upcomingLessonDates = allLessonDates.filter(x => {
			const lessonStartTime = moment(x).utcOffset(weeklyProgramItem.center.utcOffset, true);	// actual start time using center's timezone
			return lessonStartTime > now;
		}).sort((a, b) => a - b);

		const allowFutureBooking = center && center.allowFutureBooking;
		const futureBookingLimit = center && center.futureBookingLimit;
		const nextDate = upcomingLessonDates.length > 0 && upcomingLessonDates[0];

		const bookingDates = userImpersonation && allowFutureBooking ? allLessonDates :
			(allowFutureBooking ? (futureBookingLimit ? upcomingLessonDates.slice(0, futureBookingLimit) : upcomingLessonDates) :
				(nextDate ? [nextDate] : []));

		const availability = availabilityUtils.getAvailability(this.props.bookingOptions.upcomingLessons || [], lessonType, this.props.paymentTypes, center);

		const alternativeCenters = (availability === 'No' && franchisor.recommendNearbyCenters &&
			availabilityUtils.findNearbyCentersWithAvailableSpotsByWeeklyProgram(center, weeklyProgramItem, lessonType, this.props.paymentTypes,
				this.props.centers, this.props.weeklyProgram, franchisor.distanceToNearbyCenters)) || [];

		return <div className='timetable-wrapper'>
			<ReduxBlockUi block={WEEKLY_PROGRAM_ITEM_REQUEST} unblock={[WEEKLY_PROGRAM_ITEM_SUCCESS, WEEKLY_PROGRAM_ITEM_FAILURE]}>
				<Row>
					<Col md={12}>
						{fromTimetable && <BackButton title={t('FO_ProgramDetails_Back')} />}
						{!fromTimetable && <Link to={`/public/timetable?centerId=${centerId}`} className='btn btn-back btn-block-xxs'><FontAwesome name='arrow-circle-left' /> {t('FO_ProgramDetails_Back')}</Link>}
					</Col>
				</Row>
				<Row style={{ marginTop: '30px' }}>
					<Col md={8}>{weeklyProgramItem && <div className='booking-options-container' style={{ width: '100%', margin: 0, marginBottom: 20 }}>
						<ClassDetailsView
							weeklyProgramItem={weeklyProgramItem}
							upcomingLessonDates={upcomingLessonDates}
							availability={availability}
							enableUserTimeZone={this.props.franchisor.enableUserTimeZone}
						/>
					</div>}
					</Col>
					<Col md={4}>
						<BookingOptions
							children={this.props.children}
							programId={this.props.weeklyProgramItemId}
							lessonDates={bookingDates}
							nextDate={nextDate}
							bookingOptions={this.props.bookingOptions}
							onSelectStartDate={this.handleStartDateSelect}
							onSelectPaymentType={this.handlePaymentTypeSelect}
							onSelectChild={this.props.selectChild}
							onConfirm={this.handleBookingOptionsConfirm}
							onJoinWaitingList={this.handleJoinWaitingList}
							block={BOOKING_OPTIONS_FETCH_REQUEST}
							unblock={[BOOKING_OPTIONS_FETCH_SUCCESS, BOOKING_OPTIONS_FETCH_FAILURE]}
							blockChildrenInfo={CHILDREN_GRADES_REQUEST}
							unblockChildrenInfo={[CHILDREN_GRADES_SUCCESS, CHILDREN_GRADES_FAILURE]}
							center={center}
							enableUserTimeZone={this.props.franchisor.enableUserTimeZone}
							enableCurrencyConversion={this.props.franchisor.enableCurrencyConversion}
							currentCurrency={this.props.currentCurrency}
							franchisorCurrency={this.props.franchisor.currency}
							postTrial={postTrial}
							isAuthenticated={this.props.isAuthenticated}
							centerId={centerId}
						/>
						{alternativeCenters.length > 0 && <div style={{ width: '100%', margin: 0, marginBottom: 20 }} className='timetable-options'>
							<RecommendedNearbyCenters
								centers={alternativeCenters}
								onSelectCenter={(centerId) => this.props.history.push(`/public/timetable?centerId=${centerId}&termId=${weeklyProgramItem.termId}&lessonType=${lessonType}`)}
							/>
						</div>
						}
					</Col>
				</Row>

			</ReduxBlockUi>
		</div>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const centerId = Number(ownProps.match.params.centerId);
	const weeklyProgramItemId = Number(ownProps.match.params.programId);

	const queryParams = queryString.parse(ownProps.location.search);
	const lessonType = queryParams.lessonType;
	const postTrial = queryParams.postTrial;

	const { entities: { centers, grades, terms, weeklyProgram }, configuration: { franchisor }, auth: { currentUser, isAuthenticated } } = state;
	const {
		programId,
		date,
		warningMessage,
		errorMessage,
		upcomingLessons,
		childrenPaymentTypes,
		selectedChildId,
		selectedPaymentTypeId,
		isSelectJoinWaitingList,
		annualPaymentLength
	} = state.booking;

	let weeklyProgramDeepLoaded = Object.values(weeklyProgram);
	weeklyProgramDeepLoaded.forEach(item => {
		item.grade = grades[item.gradeId] || { name: '', subGrades: [] };
		item.center = centers[item.centerId] || { name: '' };
		item.term = terms[item.termId] || { name: '', schoolYear: '' };
	});

	const activeLanguage = getActiveLanguage(state.configuration.language);

	return {
		centerId,
		weeklyProgramItemId,
		center: centers[centerId],
		centers: Object.values(centers).filter(c => lessonType !== 'trial' || c.isTrialLesson).sort((a, b) => a.name.toUpperCase() < b.name.toUpperCase() ? -1 : 1),
		weeklyProgramItem: weeklyProgramDeepLoaded.find(x => x.id === weeklyProgramItemId),
		weeklyProgram: weeklyProgramDeepLoaded,
		franchisor,
		userImpersonation: currentUser && currentUser.userImpersonation,
		paymentTypes: state.lookups.paymentTypes,
		bookingOptions: {
			programId: Number(programId),
			date,
			lessonType: lessonType || '',
			warningMessage,
			errorMessage,
			upcomingLessons,
			selectedChildId,
			selectedPaymentTypeId,
			isSelectJoinWaitingList,
			postTrial,
			annualPaymentLength,
			childrenPaymentTypes: childrenPaymentTypes.map(c => ({
				child: getChild(state.parent, c.childId),
				paymentTypes: c.paymentTypes,
				errorMessage: c.errorMessage,
				joinWaitingList: c.joinWaitingList,
				isLocked: c.isLocked
			}))
		},
		fromTimetable: ownProps.location.state && ownProps.location.state.fromTimetable,
		currentCurrency: activeLanguage && activeLanguage.currencyCode,
		isAuthenticated
	};
};

export default connect(mapStateToProps, {
	fetchWeeklyProgramItem,
	loadWeeklyProgram,
	loadBookingOptions,
	selectPaymentType,
	selectChild,
	startEnrolment,
	selectJoinWaitingList
})(withNamespaces()(ClassDetails));